import React, { useEffect, useState } from "react";
import DrodpdownEntry from "./DrodpdownEntry";
import "./index.scss";
import Pagination from "react-js-pagination";
const PaginationBlock = ({ page, limit, organizations, __handlePageChange, __handleLimit, status, hide = null }) => {

	const [lmt, setLmt] = useState()
	const [cPage, setCpage] = useState()

	useEffect(() => {
		setLmt(limit)
		setCpage(page)
	}, [limit, page])



	console.log('list of list items', organizations)


	return (
		<>


			<div className="pagination-blc d-flex overflow-auto" id="paginationBlc">
				<div className="page-entry d-inline-flex align-items-center">

					{hide === null && (
						<DrodpdownEntry value={Number(limit)} _handleClick={__handleLimit} />
					)}

					<span>showing  {organizations?.pagingCounter}  to {organizations?.totalCurrentDoc <= page * limit ? organizations?.totalCurrentDoc : page * limit}  of {organizations?.totalCurrentDoc}  </span>



					{/* <span>{`Showing ${organizations?.page == organizations?.totalPages ? organizations?.totalDocs : organizations?.docs?.length * page} out of ${organizations?.totalDocs} Entries`}</span> */}
				</div>
				<ul className="pagination ms-auto">
					<Pagination
						innerClass="pagination justify-content-end pb-10 mt-auto"
						itemClass="page-item"
						linkClass="page-link"
						prevPageText="Previous"
						nextPageText="Next"
						firstPageText="First"
						lastPageText="Last"
						activePage={cPage}
						itemsCountPerPage={Number(lmt)}
						totalItemsCount={organizations?.totalCurrentDoc}

						onChange={(activePage) => {
							if (activePage !== cPage) {
								console.log('active page of pagination', activePage)
								__handlePageChange(activePage)

							}
						}}
					/>
				</ul>
			</div>
		</>
	);
}
export default PaginationBlock;


//  range starting limit{((limit *( page-1))+ 1)}